import { useState } from "react";

export const useNuevaContraseña = () => {
  const [modalExito, setModalExito] = useState(false);
  const onAceptar = () => {
    return setModalExito(false);
  };
  const onFinish = () => {
    return setModalExito(true);
  };
  return { modalExito, setModalExito, onAceptar, onFinish };
};
